import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ElectricalInspectionForm from './components/ElectricalInspectionForm';

const NewElectricalInspectionPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const assetId = searchParams.get('assetId');

    return (
        <div className="animate-in fade-in duration-500">
            <ElectricalInspectionForm
                initialAssetId={assetId || undefined}
                onBack={() => navigate('/assets?tab=electrical')}
                onSaveSuccess={() => navigate('/assets?tab=electrical')}
            />
        </div>
    );
};

export default NewElectricalInspectionPage;
